import { IGetState, TBoardId } from '../../../types/types';
import { Dispatch, ThunkAction } from '../../../types/actions';
import { boardPatchRest } from './api/helpers/boardPatchRest';

export const boardSetCardNumberValues = (
    boardId: TBoardId,
    cardNumberPrefix: string,
    cardNumberNextValue: number
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        return dispatch(boardPatchRest(boardId, {
            cardNumberPrefix,
            cardNumberNextValue
        }));
    };
    return action;
}
